/* global google */
import React from 'react';
import _ from 'lodash';
import { withGoogleMap, GoogleMap, Polygon, Polyline, withScriptjs } from 'react-google-maps';

function getLatLng (point) {
  return {lat: point[1], lng: point[0]};
}


// https://stackoverflow.com/questions/22796520/finding-the-center-of-leaflet-polygon
function getCentroid (arr) { 
  return arr.reduce(function (x,y) {
    return [x[0] + y[0] / arr.length, x[1] + y[1] / arr.length]
  }, [0, 0]);
}

const DEPTHS = {
  'LineString': 0,
  'MultiLineString': 1,
  'Polygon': 1,
  'MultiPolygon': 2,
}

class Shape {

  constructor ({ geometryType, coordinates }) {
    this.type = geometryType;
    this.coordinates = coordinates;
  }

  getFlattened () {
    return _.flattenDepth(this.coordinates, DEPTHS[this.type]);
  }

  getCentroid () {
    const center = getCentroid(this.getFlattened());
    return getLatLng(center);
  }

  getBounds () {
    let bounds = new google.maps.LatLngBounds();
    this.getFlattened().forEach(point => {
      const latLng = getLatLng(point);
      bounds.extend(latLng);
    });
    return bounds;
  }

  getPaths (coordinates) {
    return coordinates.map(line => {
      return line.map(point => getLatLng(point));
    });
  }

  renderLineString (coordinates, key) {
    const path = coordinates.map(point => getLatLng(point));
    return <Polyline key={key} path={path} options={{strokeColor: '#ff2527', strokeWeight: 6}}/>;
  }

  renderMultiLineString (coordinates) {
    return coordinates.map((line, i) => this.renderLineString(line, i));
  }

  renderPolygon (coordinates, key) {
    const paths = this.getPaths(coordinates);
    return <Polygon key={key} paths={paths} options={{strokeColor: '#ff2527', strokeWeight: 6}} />;
  }

  renderMultiPolygon (coordinates) {
    return coordinates.map((polygon, i) => this.renderPolygon(polygon, i));
  }

  render () {
    const method = this['render' + this.type].bind(this);
    return method(this.coordinates);
  }

}


const GMap = withScriptjs(withGoogleMap(props => {
  const shape = new Shape(props);
  return (
    <GoogleMap
      ref={(map) => props.onMapLoad(map, shape.getBounds())}
      defaultZoom={16}
      defaultOptions={{scrollwheel: false}}
    >
      {shape.render()}
    </GoogleMap>
  );
}));


export default GMap;
